import { Patient } from "@/store/modules/patient/types";
import { Alert } from "@/store/types";

export function demoSortBy(patients: Array<Patient>, sortBy: string) {
  switch (sortBy) {
    case "rooms":
      return patients.sort((a, b) => {
        return parseInt(a.census.roomSys, 10) - parseInt(b.census.roomSys, 10);
      });
    case "sofa":
      return atomValueComparer(patients, "sofa");
    case "alerts":
      return patients
        .sort((a, b) => {
          return (
            getBestAlertLevel(a.census.alert) -
            getBestAlertLevel(b.census.alert)
          );
        })
        .reverse();
    case "acuity":
      // Sort (grouping) is done by the acuity view
      break;
    case "caseState":
      return patients.sort((a, b) => {
        if (a.census.caseStage && b.census.caseStage) {
          const diff = a.census.caseStage - b.census.caseStage;
          if (diff !== 0) {
            return diff;
          }
        }
        return a.census.caseState - b.census.caseState;
      });
  }
  return patients;
}

function getBestAlertLevel(alerts: Array<Alert>) {
  let highestAlert = 0;
  alerts.forEach(alert => {
    let slot1Bonus = 0;
    if (alert.slot === 1) {
      slot1Bonus = 20;
    }
    highestAlert = Math.max(highestAlert, alert.level + slot1Bonus);
  });
  return highestAlert;
}

function atomValueComparer(patients: Array<Patient>, atomName: string) {
  return patients.sort((a, b) => {
    if (!a.census.atoms[atomName] || !b.census.atoms[atomName]) {
      return 0;
    }
    return a.census.atoms[atomName].value - b.census.atoms[atomName].value;
  });
}

export function demoFilter(patients: Array<Patient>, filter: string) {
  if (!filter) {
    return patients;
  }
  let filteredPatients: Array<Patient> = patients;
  let filterList = filter.split(",");
  let myPatients = filterList.includes("myPatients");
  // We want to filter to occupied and then make the first ones
  // your patients
  if (myPatients) {
    filterList.unshift("hasPatient", "myPatients");
  }

  // Remove duplicates
  filterList = [...new Set(filterList)];

  filterList.forEach(filter => {
    if (filterFunctions[filter]) {
      filteredPatients = filteredPatients.filter(filterFunctions[filter]);
    } else {
      // filter is not implemented, hide all patients
      filteredPatients = [];
    }
  });
  return filteredPatients;
}

const filterFunctions: Record<string, any> = {
  myPatients: (_patient: Patient, index: number) => {
    return index < 4;
  },
  hasPatient: (patient: Patient) => {
    return patient.census.regNum !== "";
  },
  adult: (patient: Patient) => {
    // Always show patients with no dob entered: -1
    return (
      patient.census.age == -1 ||
      (patient.census.age >= 18 &&
        patient.census.age <= Number.MAX_SAFE_INTEGER)
    );
  },
  peds: (patient: Patient) => {
    // Always show patients with no dob entered: -1
    return (
      patient.census.age == -1 ||
      (patient.census.age >= 0 && patient.census.age <= 17)
    );
  },
  vent: (patient: Patient) => {
    return alertAtomExists(patient, "ventStatus");
  },
  nitricOxide: (patient: Patient) => {
    return alertAtomExists(patient, "nitricOxide");
  },
  mcs: (patient: Patient) => {
    return alertAtomExists(patient, "pump");
  },
  ecmo: (patient: Patient) => {
    return (
      alertAtomExists(patient, "pump") &&
      patient.census.alert.filter(a => {
        return a.message.includes("ECMO");
      }).length === 1
    );
  }
};

function alertAtomExists(patient: Patient, atomName: string) {
  return (
    patient.census.alert.filter(alert => alert.atom === atomName).length >= 1
  );
}
